import React, { FC } from 'react';

import ErrorBoundary from '@buyside/components/presentation/ErrorBoundary/errorBoundary';
import UserProfileShowPageContainer from '@buyside/components/container/UserProfileShow/UserProfileShowPageContainer';

const UserProfileShowPageRoot: FC<{ profileId: string }> = ({ profileId }) => {
  if (!profileId) return;

  return (
    <ErrorBoundary pageName="the user profile">
      <UserProfileShowPageContainer profileId={parseInt(profileId)} />
    </ErrorBoundary>
  );
};

export default UserProfileShowPageRoot;
